// packages
import { makeStyles } from '@rneui/themed';

export default makeStyles(() => ({
  mainContainer: {
    width: '90%'
  }
}));
